import {SELECTED_JOURNAL_IDS_KEY} from "../constants";
import {getJournals} from "./settings";
import {getFromLocalStorage, setToLocalStorage} from "./localStorage";

export const getSelectedJournalIds = async () => {
    const savedJournalIds = getFromLocalStorage(SELECTED_JOURNAL_IDS_KEY, []);

    if (savedJournalIds) {
        return savedJournalIds;
    } else {
        const { data: response } = await getJournals();
        const arrResponse = response?.journals ?? [];

        const selectedJournalIds = arrResponse.map((journal) => journal.id);

        setToLocalStorage(SELECTED_JOURNAL_IDS_KEY, selectedJournalIds);

        return selectedJournalIds;
    }
};
